import React from 'react';
import { Waypoint } from 'react-waypoint';

import { Artist as ArtistCell, ArtistSlim, Artwork as ArtworkCell, Gallery as GalleryCell, ShowVertical } from '../common/container/Cell.jsx';
import { ArtworkGridContainer, NoResults, Spaced, Tab, Title, TitleSpaced, forResource } from '../common/container/Container.jsx';
import { default as FilterContainer } from '../common/container/Filter.jsx';
import { withSubmission } from '../common/container/Form.jsx';
import { Cover as LoadingCover, Fullscreen as LoadingFull, Indicator as LoadingIndicator } from '../common/container/Loading.jsx';
import { GalleryContact, ListArtworkAdd } from '../common/container/Popup.jsx';
import Prospects from '../common/container/Prospects.jsx';
import { Artwork as ArtworkSlider, Galleries as GalleriesSlider, Shows as ShowsSlider, Artists as ArtistsSlider } from '../common/container/Slider.jsx';
import { Button, Follow as FollowButton, LinkButton, Text as TextButton } from '../common/input/Button.jsx';
import { Input } from '../common/input/Text.jsx';

let _GalleryInst;
class _Gallery extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            artists: {
                loading: true
            },
            artwork: {
                loading: false,
                q: {
                    dir: 1,
                    limit: 20,
                    offset: 0,
                    order: 2
                }
            },
            loading: true,
            showsCurrent: {
                total: 0
            },
            showsPast: {
                loading: false,
                q: {
                    limit: 18,
                    offset: 0,
                    when: 1
                },
                total: 0
            },

            Email: '',
            Name: ''
        };

        this.sortOptions = [
            { display: 'Popular', value: 0 },
            { display: 'Newest', value: 2 },
            { display: 'Suggested', value: 3 }
        ];

        this._parseGalleries = this._parseGalleries.bind(this);
        this._parseShows = this._parseShows.bind(this);
        this.configureTabs = this.configureTabs.bind(this);
        this.getArtists = this.getArtists.bind(this);
        this.getArtwork = this.getArtwork.bind(this);
        this.getGalleriesNeighbors = this.getGalleriesNeighbors.bind(this);
        this.getShowsCurrent = this.getShowsCurrent.bind(this);
        this.getShowsPast = this.getShowsPast.bind(this);
        this.handleArtistFollowChange = this.handleArtistFollowChange.bind(this);
        this.handleArtworkFilterChange = this.handleArtworkFilterChange.bind(this);
        this.handleArtworkLikeChange = this.handleArtworkLikeChange.bind(this);
        this.handleArtworkWaypointEnter = this.handleArtworkWaypointEnter.bind(this);
        this.handleClaimSubmit = this.handleClaimSubmit.bind(this);
        this.handleContact = this.handleContact.bind(this);
        this.handleContactClose = this.handleContactClose.bind(this);
        this.handleFollowChange = this.handleFollowChange.bind(this);
        this.handleGalleryFollowChange = this.handleGalleryFollowChange.bind(this);
        this.handleListArtworkAddModalClose = this.handleListArtworkAddModalClose.bind(this);
        this.handleNeighboringGalleryArtworkLikeChange = this.handleNeighboringGalleryArtworkLikeChange.bind(this);
        this.handleNewsletterSubmit = this.handleNewsletterSubmit.bind(this);
        this.handleShowsWaypointEnter = this.handleShowsWaypointEnter.bind(this);
    }

    componentDidMount() {
        _GalleryInst = true;

        const component = this;
        component.props.onRegisterRequestCallback(function (responseData) {
            Artcloud.mkt.galleries._isfollowing(responseData);

            const id = responseData.GalleryId;

            const user = Artcloud.auth.user;
            if (user) {
                let name;
                if (user.Name) {
                    name = user.Name.Full;
                }
                component.setState({
                    CanProspect: user.Permissions && user.Permissions.CanProspect,
                    Email: user.Email,
                    Name: name,
                    Type: user.Type.Value
                });
            }

            if (responseData.Ghost) {
                component.getArtists(id);
                component.setState({
                    loading: false
                });
            } else {
                component.getShowsCurrent(id);
                component.getArtists(id);
                if (responseData.HasArt) {
                    component.getArtwork(id);
                } else {
                    component.getGalleriesNeighbors(id);
                }
            }
        });
    }

    componentWillUnmount() {
        _GalleryInst = undefined;

        if (this.artistsRequest) {
            this.artistsRequest.abort();
            this.artistsRequest = null;
        }
        if (this.artworkRequest) {
            this.artworkRequest.abort();
            this.artworkRequest = null;
        }
        if (this.galleriesRequest) {
            this.galleriesRequest.abort();
            this.galleriesRequest = null;
        }
        if (this.showsRequest) {
            this.showsRequest.abort();
            this.showsRequest = null;
        }
    }

    _parseGalleries(responseData) {
        responseData.forEach(function (d) {
            if (d.Image) {
                d.ImgSrc = d.Image.MediumUrl;
            }
            Artcloud.mkt.galleries._isfollowing(d);
        });
        return responseData;
    }

    _parseShows(responseData) {
        const component = this;
        responseData.Shows.forEach(function (d) {
            d.Company = component.props.data.Company;
            if (d.Image) {
                d.ImgSrc = Artcloud.cdn.url(d.Image.S3Id, 260, 200, 'c_fill');
            }
        });
        return responseData.Shows;
    }

    configureTabs() {
        const tabs = [
            { active: true, label: 'Overview', tab: 'overview' },
            { label: 'Artists', tab: 'artists' }
        ];
        
        if (this.props.data) {
            if (this.props.data.Ghost) {
                
            } else {
                if (this.props.data.HasArt) {
                    tabs.push({ label: 'Artwork', tab: 'artwork' });
                }
                if (this.props.data.Bio && this.props.data.Bio.length) {
                    tabs.push({ label: 'About', tab: 'about' });
                }
                if (this.state.showsCurrent && this.state.showsPast && (this.state.showsCurrent.total + this.state.showsPast.total) > 0) {
                    tabs.push({ label: 'Shows', tab: 'shows' });
                }
                if (!this.props.data.HasArt) {
                    tabs.push({ label: 'Neighboring Galleries', tab: 'galleries' });
                }
            }

            if (this.state.CanProspect) {
                tabs.push({ label: 'Prospects', tab: 'prospects' });
            }
        }

        this.props.onConfigureTabs(tabs, this.props.tab || 'overview');
    }

    getArtists(galleryId) {
        const component = this;
        component.artistsRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.galleries.artists.get(galleryId),
            null,
            function (responseData) {
                component.artistsRequest = null;

                responseData.Artists.forEach(function (d) {
                    if (d.Image) {
                        d.ImgSrc = d.Image.MediumUrl;
                    }
                    Artcloud.mkt.artists._isfollowing(d);
                });
                component.setState({
                    artists: {
                        data: responseData.Artists
                    }
                }, function () {
                    component.configureTabs();
                });
            },
            function (jqXHR, textStatus) {
                component.artistsRequest = null;
                component.setState({
                    artists: {
                        data: []
                    }
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getArtwork(galleryId) {
        const component = this;
        const state = component.state.artwork;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            artwork: state
        });
        const query = { ...state.q };
        let data;
        for (let id in query) {
            data = query[id];
            if (!data || data.value == undefined) {
                continue;
            }
            query[id] = data.value;
        }
        component.artworkRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.galleries.art.get(galleryId),
            query,
            function (responseData) {
                component.artworkRequest = null;

                responseData.Data.forEach(function (d) {
                    Artcloud.mkt.art._isfavorite(d);
                });
                let data = state.data || [];
                state.data = data.concat(responseData.Data);
                state.q.offset += responseData.Data.length;
                state.hasMore = responseData.HasMore;

                state.loading = false;
                component.setState({
                    artwork: state
                });
            },
            function (jqXHR, textStatus) {
                component.artworkRequest = null;

                state.loading = false;
                component.setState({
                    artwork: state
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getGalleriesNeighbors(galleryId) {
        const component = this;
        component.galleriesRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.galleries.neighbors.galleries.get(galleryId),
            { limit: 30, offset: 0, type: 0 },
            function (responseData) {
                component.galleriesRequest = null;

                component.setState({
                    neighboringGalleries: {
                        data: component._parseGalleries(responseData)
                    }
                });
            },
            function (jqXHR, textStatus) {
                component.galleriesRequest = null;
                component.setState({
                    neighboringGalleries: {
                        data: []
                    }
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getShowsCurrent(galleryId) {
        const component = this;
        component.showsRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.galleries.shows.get(galleryId),
            { when: 0 },
            function (responseData) {
                component.showsRequest = null;

                component._parseShows(responseData);
                component.setState({
                    showsCurrent: {
                        data: responseData.Shows,
                        total: responseData.Total
                    }
                });
                component.getShowsPast(galleryId);
            },
            function (jqXHR, textStatus) {
                component.showsRequest = null;
                component.setState({
                    loading: false
                });
                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    getShowsPast(galleryId) {
        const component = this;
        const state = component.state.showsPast;
        if (state.loading) {
            return;
        }
        state.loading = true;
        component.setState({
            showsPast: state
        });
        component.showsRequest = Artcloud.api.get(
            Artcloud.url.vendor.marketplace.galleries.shows.get(galleryId),
            state.q,
            function (responseData) {
                component.showsRequest = null;

                component._parseShows(responseData);

                let data = state.data || [];
                state.data = data.concat(responseData.Shows);

                state.q.offset += responseData.Shows.length;
                state.total = responseData.Total;

                state.loading = false;
                component.setState({
                    loading: false,
                    showsPast: state
                }, function () {
                    component.configureTabs();
                });
            },
            function (jqXHR, textStatus) {
                component.showsRequest = null;

                state.loading = false;
                component.setState({
                    showsPast: state
                });

                Artcloud.api.fail(jqXHR, textStatus);
            }
        );
    }

    handleArtistFollowChange(d) {
        const state = this.state.artists;
        let artist;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtistId != d.ArtistId) {
                continue;
            }
            artist = temp;
            break;
        }
        if (!artist) {
            return;
        }
        const component = this;
        Artcloud.mkt.artists.updateFollowing(artist.ArtistId, !artist.IsFollowing, artist.Name, function (success) {
            if (success != true || !_GalleryInst) {
                return;
            }
            artist.IsFollowing = !artist.IsFollowing;
            component.setState({
                artists: state
            });
        });
    }

    handleArtworkFilterChange(name, value) {
        const component = this;
        if (component.artworkRequest) {
            component.artworkRequest.abort();
            component.artworkRequest = null;
        }
        const state = component.state.artwork;
        state.data = undefined;
        state.hasMore = undefined;
        state.q[name] = value;
        state.q.offset = 0;

        component.setState({
            artwork: state
        }, function () {
            component.getArtwork(component.props.data.GalleryId)
        });
    }

    handleArtworkLikeChange(d) {
        const state = this.state.artwork;
        let artwork;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.ArtId != d.ArtId) {
                continue;
            }
            artwork = temp;
            break;
        }
        if (!artwork) {
            return;
        }
        const component = this;
        Artcloud.mkt.art.updateFavorite(artwork.ArtId, !artwork.IsFavorite, artwork.Title, function () {
            if (!_GalleryInst) {
                return;
            }
            artwork.IsFavorite = !artwork.IsFavorite;
            component.setState({
                artwork: state,
                listArtworkAddModal: {
                    data: artwork,
                    visible: true
                }
            });
        });
    }

    handleArtworkWaypointEnter() {
        if (!this.state.artwork.data || (this.state.artwork.data && this.state.artwork.hasMore == false)) {
            return;
        }
        this.getArtwork(this.props.data.GalleryId);
    }

    handleClaimSubmit() {
        const component = this;
        component.setState({
            disableClaim: true
        });
        Artcloud.api.post(
            Artcloud.url.vendor.marketplace.forms.claims.post(),
            { galleryId: component.props.data.GalleryId },
            function (responseData) {
                if (!_GalleryInst) {
                    return;
                }
                component.setState({
                    claimMessage: responseData.Message,
                    disableClaim: undefined
                });
            },
            function (jqXHR) {
                if (!_GalleryInst) {
                    return;
                }
                let message;
                if (jqXHR.responseJSON) {
                    message = jqXHR.responseJSON.Message;
                }
                if (!message) {
                    message = 'Error claiming gallery profile.';
                }
                component.setState({
                    claimMessage: message,
                    disableClaim: undefined
                });
            }
        );
    }

    handleContact(event) {
        if (event) {
            event.preventDefault();
        }
        this.setState({
            contactModal: true
        });
    }

    handleContactClose() {
        this.setState({
            contactModal: undefined
        });
    }

    handleFollowChange() {
        const component = this;
        const data = this.props.data;
        Artcloud.mkt.galleries.updateFollowing(data.GalleryId, !data.IsFollowing, data.Company, function (success) {
            if (success != true || !_GalleryInst) {
                return;
            }
            data.IsFollowing = !data.IsFollowing;
            component.props.onUpdateData(data);
        });
    }

    handleGalleryFollowChange(d) {
        const state = this.state.neighboringGalleries;
        let gallery;
        for (let i = 0; i < state.data.length; i++) {
            let temp = state.data[i];
            if (!temp || temp.GalleryId != d.GalleryId) {
                continue;
            }
            gallery = temp;
            break;
        }
        if (!gallery) {
            return;
        }
        const component = this;
        Artcloud.mkt.galleries.updateFollowing(gallery.GalleryId, !gallery.IsFollowing, gallery.Company, function (success) {
            if (success != true || !_GalleryInst) {
                return;
            }
            gallery.IsFollowing = !gallery.IsFollowing;
            component.setState({
                neighboringGalleries: state
            });
        });
    }

    handleListArtworkAddModalClose() {
        this.setState({
            listArtworkAddModal: undefined
        });
    }

    handleNeighboringGalleryArtworkLikeChange(d) {
        if (!_GalleryInst) {
            return;
        }
        this.setState({
            listArtworkAddModal: {
                data: d,
                visible: true
            }
        });
    }

    handleNewsletterSubmit(data, callback) {
        if (this.state.disableNewsletter) {
            return;
        }
        const component = this;
        component.setState({
            disableNewsletter: true
        });
        const galleryId = component.props.data.GalleryId;
        const postData = {
            Email: data.Email,
            GalleryId: galleryId,
            Name: data.Name
        }
        Artcloud.api.post(
            Artcloud.url.vendor.marketplace.galleries.subscriptions.post(galleryId),
            postData,
            function () {
                if (!_GalleryInst) {
                    return;
                }
                component.setState({
                    disableNewsletter: false
                });
                if (callback) {
                    callback(true, 'You have been added to our newsletter. Thank you!');
                }
            },
            function (jqXHR) {
                if (!_GalleryInst) {
                    return;
                }
                component.setState({
                    disableNewsletter: false
                });
                if (!callback) {
                    return;
                }
                callback(false, 'Error joining newsletter.', jqXHR);
            }
        );
    }

    handleShowsWaypointEnter() {
        if (!this.state.showsPast.data || (this.state.showsPast.data && this.state.showsPast.q.offset >= this.state.showsPast.total)) {
            return;
        }
        this.getShowsPast(this.props.data.GalleryId);
    }

    render() {
        const data = this.props.data || {};
        let imageStyle;
        if (data.Logo) {
            imageStyle = {
                backgroundColor: '#fff',
                backgroundImage: `url('${data.Logo.MediumUrl}')`,
                backgroundSize: '100% auto'
            };
        }
        let hasFilter;
        let className = 'tabs__content tabs__content__active';
        if (this.props.tab == 'artwork') {
            className += ' section--masonry';
            hasFilter = this.state.artwork.q.color != undefined ||
                this.state.artwork.q.maxHeight > 0 || this.state.artwork.q.minHeight > 0 ||
                this.state.artwork.q.maxPrice > 0 || this.state.artwork.q.minPrice > 0 ||
                this.state.artwork.q.maxWidth > 0 || this.state.artwork.q.minWidth > 0;
        } 
        const hasCurrentShows = this.state.showsCurrent && this.state.showsCurrent.data && this.state.showsCurrent.data.length > 0;
        return (
            <React.Fragment>
                <Spaced className="cover__container cover--city section">
                    <div className="cover__img" style={imageStyle}>
                        {
                            !data.Logo &&
                            <div className="cover__img--blank">
                                <div className="cover__img--blank__inn">
                                    <span className="i i--gallery"></span>
                                    <span className="cover__img__text">Gallery</span>
                                </div>
                            </div>
                        }
                    </div>
                    <div className="cover__content">
                        <div className="cover__name">
                            <h1>{data.Company}</h1>
                            <h3 className="cover__meta">
                                <div className="cover__location">{data.Location}</div>
                            </h3>
                            <FollowButton data={data} onChange={this.handleFollowChange} />
                        </div>
                        <div className="cover__contact">
                            {
                                data.Website != undefined &&
                                data.Website != null &&
                                <Button config={{ color: 'light-grey', size: 'tiny', style: 'fill' }} link={data.Website} target="_blank">Website</Button>
                            }
                            {
                                !data.Ghost &&
                                <LinkButton config={{ color: 'dark', size: 'tiny', style: 'fill' }} onClick={this.handleContact}>Contact</LinkButton>
                            }
                        </div>
                    </div>
                    {
                        !data.Ghost &&
                        <div className="cover__newsletter">
                            <div className="section__title section__title--small">
                                <h2>Join Gallery Newsletter</h2>
                            </div>
                            <NewsletterForm
                                className="form__inner cover__newsletter__form"
                                id="newsletterForm"
                                initialState={{ Email: this.state.Email, Name: this.state.Name }}
                                loading={this.state.disableNewsletter}
                                onSubmit={this.handleNewsletterSubmit} />
                            {
                                this.state.disableNewsletter &&
                                <LoadingFull />
                            }
                        </div>
                    }
                </Spaced>
                {
                    data.Ghost &&
                    <section className="section spacer--bottom-s">
                        <div className="container">
                            <div className="blank__cont blank--outline blank--single">
                                {
                                    this.state.claimMessage != undefined &&
                                    <p className="blank__text">{this.state.claimMessage}</p>
                                }
                                {
                                    this.state.claimMessage == undefined &&
                                    <React.Fragment>
                                        <p className="blank__text blank__text--two-btns">This is a community-generated profile. Click the button to the right to claim it.</p>
                                        <div className="blank__btn blank__btn--two">
                                            <a className="btn btn--outline btn--light btn--large" href="/manager-for-galleries" target="_blank">
                                                <React.Fragment>Learn More about ArtCloud</React.Fragment>
                                            </a>
                                            <button className="btn btn--blue btn--fill" style={{ cursor: 'pointer' }} onClick={this.handleClaimSubmit}>
                                            <React.Fragment>Claim gallery</React.Fragment> <span className="hide--m">profile</span>
                                            </button>
                                        </div>
                                        {
                                            this.state.disableClaim &&
                                            <LoadingCover />
                                        }
                                    </React.Fragment>
                                }
                            </div>
                        </div>
                    </section>
                }
                {
                    this.state.loading &&
                    <LoadingIndicator />
                }
                {
                    !data.Ghost &&
                    <Tab tabs={this.props.tabs} onClick={this.props.onTabClick} />
                }
                {
                    data.Ghost &&
                    <Tab tabs={this.props.tabs} onClick={this.props.onTabClick} />
                }
                <div className="spacer-bottom section">
                    { data && !data.Ghost && 
                        <Spaced className={className}>
                            {
                                this.props.tab == 'overview' &&
                                <React.Fragment>
                                    {
                                        this.state.showsCurrent.total > 0 &&
                                        hasCurrentShows == true &&
                                        <React.Fragment>
                                            <TitleSpaced>
                                                <h3>Current and Upcoming Shows</h3>
                                            </TitleSpaced>
                                            <ShowsSlider
                                                data={this.state.showsCurrent.data}
                                                q={{ limit: 30, offset: 0 }}
                                                slideProps={{ height: 250, setWidth: false, index: 2 }}
                                                sliderClassName="slider--grid-6"
                                            />
                                            <br />
                                        </React.Fragment>
                                    }
                                    {
                                        this.props.data.Bio && this.props.data.Bio.length &&
                                        <div className="information__block">
                                            <TitleSpaced>
                                                <h3>About</h3>
                                            </TitleSpaced>
                                            <Spaced>
                                                <div className="container--spaced__row">
                                                    <div className="grid grid--4">
                                                        <img alt={this.props.data.Company} src={this.props.data.Image && this.props.data.Image.LargeUrl} height="auto" width="100%" />
                                                    </div>
                                                    <div className="grid grid--8 spacer--mtop">
                                                        <div className="section--narrow">
                                                            <p className="text--details">
                                                                <span className="all">{this.props.data.Bio}</span>
                                                            </p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Spaced>
                                        </div>
                                    }
                                    
                                    <TitleSpaced>
                                        <h3>Artists</h3>
                                    </TitleSpaced>
                                    
                                    {
                                        this.state.artists.loading &&
                                        <LoadingIndicator />
                                    }
                                    {
                                        this.state.artists.data &&
                                        <React.Fragment>
                                            {
                                                this.state.artists.data.length == 0 &&
                                                <NoResults display="No Artists" />
                                            }
                                            {
                                                this.state.artists.data.length > 0 &&
                                                <Spaced className="artist__grid--cont">
                                                    <ArtistsSlider
                                                        q={{ limit: 30, offset: 0, order: 'density' }}
                                                        data={ this.state.artists.data.slice(0, 100)}
                                                        slideProps={{ height: 250, setWidth: false, index: 5 }}
                                                        sliderClassName="slider--grid-2"
                                                    />
                                                </Spaced>
                                            }
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            }
                            {
                                this.props.tab == 'artists' &&
                                <React.Fragment>
                                    {
                                        this.state.artists.loading &&
                                        <LoadingIndicator />
                                    }
                                    {
                                        this.state.artists.data &&
                                        <React.Fragment>
                                            {
                                                this.state.artists.data.length == 0 &&
                                                <NoResults display="No Artists" />
                                            }
                                            {
                                                this.state.artists.data.length > 0 &&
                                                <Spaced className="artist__grid--cont">
                                                    {this.state.artists.data.map((d) => <ArtistCell key={d.ArtistId} d={d} fixedHeight={true} onFollowChange={this.handleArtistFollowChange} />)}
                                                </Spaced>
                                            }
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            }
                            {
                                this.props.tab == 'artwork' &&
                                this.state.artwork &&
                                <div>
                                    <div className="grid grid--3">
                                        <div className="widget--block">
                                            <h6 className="sidebar__widget__title">Sort By</h6>
                                            <FilterContainer
                                                filters={this.state.artwork.q}
                                                renderOptions={{ colors: true, height: true, price: true, width: true }}
                                                sortOptions={this.sortOptions}
                                                onChange={this.handleArtworkFilterChange} />
                                        </div>
                                    </div>
                                    <div className="grid grid--9">
                                        {
                                            this.state.artwork.data &&
                                            this.state.artwork.data.length == 0 &&
                                            <React.Fragment>
                                                {
                                                    !hasFilter &&
                                                    <NoResults display="No Artwork" />
                                                }
                                                {
                                                    hasFilter &&
                                                    <div>
                                                        <div className="blank__cont blank--fill blank--single">
                                                            <p className="blank__text">No results. Try updating filters.</p>
                                                        </div>
                                                    </div>
                                                }
                                            </React.Fragment>
                                        }
                                        {
                                            this.state.artwork.data &&
                                            this.state.artwork.data.length > 0 && (
                                                <ArtworkGridContainer id="art" sizeClassName="art__container art--adapt grid--4" onWaypointEnter={this.handleArtworkWaypointEnter}>
                                                    {
                                                        this.state.artwork.data.map((d) => <ArtworkCell key={d.ArtId} className="grid--4" d={d} onLikeChange={this.handleArtworkLikeChange} cols={3} />)
                                                    }
                                                </ArtworkGridContainer>
                                            )
                                        }
                                        {
                                            this.state.artwork.loading &&
                                            <LoadingIndicator />
                                        }
                                    </div>
                                </div>
                            }
                            {
                                this.props.tab == 'about' &&
                                <div className="information__block">
                                    <Spaced>
                                        <div className="container--spaced__row">
                                            <div className="grid grid--4">
                                                <img alt={this.props.data.Company} src={this.props.data.Image && this.props.data.Image.LargeUrl} height="auto" width="100%" />
                                            </div>
                                            <div className="grid grid--8 spacer--mtop">
                                                <div className="section--narrow">
                                                    <div className="section__title section__title--small">
                                                        <h2>About</h2>
                                                    </div>
                                                    <p className="text--details">
                                                        <span className="all">{this.props.data.Bio}</span>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </Spaced>
                                </div>
                            }
                            {
                                this.props.tab == 'galleries' &&
                                <div className="section--gallery">
                                    {
                                        !this.state.neighboringGalleries &&
                                        <LoadingIndicator />
                                    }
                                    {
                                        this.state.neighboringGalleries &&
                                        this.state.neighboringGalleries.data &&
                                        <React.Fragment>
                                            {
                                                this.state.neighboringGalleries.data.length == 0 &&
                                                <NoResults display="No Galleries" />
                                            }
                                            {
                                                this.state.neighboringGalleries.data.length > 0 &&
                                                <Spaced className="gallery__grid__cont">
                                                    {this.state.neighboringGalleries.data.map((d) => <_GalleryCell key={d.GalleryId} d={d} onFollowChange={this.handleGalleryFollowChange} />)}
                                                </Spaced>
                                            }
                                        </React.Fragment>
                                    }
                                </div>
                            }
                            {
                                this.props.tab == 'shows' &&
                                <React.Fragment>
                                    {
                                        hasCurrentShows == true &&
                                        <React.Fragment>
                                            <TitleSpaced>
                                                <h3>Current and Upcoming</h3>
                                            </TitleSpaced>
                                            <Spaced className="show__grid--cont">
                                                {this.state.showsCurrent.data.map((d) => <ShowCell key={d.ShowId} d={d} />)}
                                            </Spaced>
                                            <br />
                                        </React.Fragment>
                                    }
                                    {
                                        this.state.showsPast.data &&
                                        this.state.showsPast.data.length > 0 &&
                                        <React.Fragment>
                                            <TitleSpaced pad={hasCurrentShows == true}>
                                                <h3>Past</h3>
                                            </TitleSpaced>
                                            <Spaced className="show__grid--cont container--waypoint">
                                                {this.state.showsPast.data.map((d) => <ShowCell key={d.ShowId} d={d} />)}
                                                <div className="loading--waypoint">
                                                    <Waypoint onEnter={this.handleShowsWaypointEnter} />
                                                </div>
                                            </Spaced>
                                            {
                                                this.state.showsPast.loading &&
                                                <LoadingIndicator />
                                            }
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            }
                            {this.props.tab == 'prospects' &&
                                <Prospects url={Artcloud.url.vendor.marketplace.galleries.prospects.get(this.props.data.GalleryId)} />}
                        </Spaced>
                    }
                    { data && data.Ghost &&
                        <Spaced className={className}>
                            { this.props.tab == 'overview' &&
                                <React.Fragment>
                                    <ArtistsSlider
                                        className="spacer--bottom"
                                        id="artists"
                                        // style={{ marginTop: '50px' }}
                                        title="Artists"
                                        titleSmall={true}
                                        data={this.state.artists.data.filter(x => x.Image != null)} />
                                    <GalleriesSlider
                                        className="spacer--bottom"
                                        id={this.props.data.GalleryId}
                                        title="Related Galleries"
                                        titleSmall={true}
                                        url={Artcloud.url.vendor.marketplace.galleries.related.get(this.props.data.GalleryId)}
                                        onParseResults={this._parseGalleries} />
                                    <ArtworkSlider
                                        className="spacer--bottom"
                                        hideOnEmpty={true}
                                        id={this.props.data.GalleryId}
                                        slideProps={{ style: { minWidth: '115px' }, onLikeChange: this.handleNeighboringGalleryArtworkLikeChange }}
                                        title="Related Artwork"
                                        titleSmall={true}
                                        url={Artcloud.url.vendor.marketplace.galleries.art.related.get(this.props.data.GalleryId)} />
                                    <GalleriesSlider
                                        className="spacer--bottom"
                                        id={this.props.data.GalleryId}
                                        q={{ limit: 30, offset: 0, type: 0 }}
                                        title="Nearby Galleries"
                                        titleSmall={true}
                                        url={Artcloud.url.vendor.marketplace.galleries.neighbors.galleries.get(this.props.data.GalleryId)}
                                        onParseResults={this._parseGalleries} />
                                    <ShowsSlider
                                        id={this.props.data.GalleryId}
                                        q={{ limit: 8, offset: 0 }}
                                        title="Local Shows"
                                        titleSmall={true}
                                        url={Artcloud.url.vendor.marketplace.galleries.neighbors.shows.get(this.props.data.GalleryId)}
                                        onParseResults={this._parseShows} />
                                </React.Fragment>
                            }
                            {
                                this.props.tab == 'artists' &&
                                <React.Fragment>
                                {
                                    this.state.artists.loading &&
                                    <LoadingIndicator />
                                }
                                {
                                    this.state.artists.data &&
                                    <React.Fragment>
                                        {
                                            this.state.artists.data.length > 0 &&
                                            <React.Fragment>
                                                {/* <Title>
                                                    <h2>Artists</h2>
                                                </Title> */}
                                                <Spaced className="artist__grid--cont spacer--bottom">
                                                    {this.state.artists.data.map((d) => <ArtistSlim key={d.Slug} d={d} />)}
                                                </Spaced>
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                }
                                </React.Fragment>
                            }
                            {this.props.tab == 'prospects' &&
                                <Prospects url={Artcloud.url.vendor.marketplace.galleries.prospects.get(this.props.data.GalleryId)} />}
                        </Spaced>
                    }
                </div>
                {
                    this.state.contactModal &&
                    <GalleryContact data={this.props.data} user={Artcloud.auth.user} onClose={this.handleContactClose} />
                }
                {
                    this.state.listArtworkAddModal &&
                    this.state.listArtworkAddModal.visible &&
                    <ListArtworkAdd data={this.state.listArtworkAddModal.data} onClose={this.handleListArtworkAddModalClose} />
                }
            </React.Fragment>
        );
    }
}

function _GalleryCell(props) {
    return <GalleryCell fixedHeight={true} {...props} />;
}

function ShowCell(props) {
    return (
        <div className="grid grid--6 spacer--bottom">
            <ShowVertical
                className="show__grid"
                cols={2}
                slider={false}
                {...props} />
        </div>
    )
}

function _NewsletterForm(props) {
    return (
        <div className="form__inner__content">
            <div className="input__container input--ir">
                <Input
                    config={{ border: 'outline', color: 'grey', size: 'medium' }}
                    disabled={props.loading || props.success}
                    name="Name"
                    placeholder="Name"
                    required
                    type="text"
                    value={props.state.Name}
                    onChange={props.onChange} />
                <Input
                    config={{ border: 'outline', color: 'grey', size: 'medium' }}
                    disabled={props.loading || props.success}
                    name="Email"
                    placeholder="Email Address"
                    required
                    type="email"
                    value={props.state.Email}
                    onChange={props.onChange} />
                <TextButton
                    config={{ color: 'white', style: 'fill' }}
                    disabled={props.loading || props.success}
                    form={true}
                    type="submit">
                    Submit
                </TextButton>
            </div>
        </div>
    );
}
const NewsletterForm = withSubmission(_NewsletterForm);

const Gallery = forResource(_Gallery, Artcloud.url.vendor.marketplace.galleries.getid);
export default Gallery;